module.exports = __webpack_public_path__ + "static/media/KQGroup.f55aefeb.jpg";